import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input
} from '@angular/core';
import { OverlayMatIconInput } from '../custom-tool-tip/custom-tool-tip';
import { OverlayMatIcon } from './mat-icon';

@Component({
  selector: 'rpe-mat-icon-tooltip',
  templateUrl: './mat-icon-tooltip.component.html',
  styleUrls: ['./mat-icon-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MatIconTooltipComponent implements OnInit {
  @Input() matIconOverlayInput: OverlayMatIcon;

  overlayInput: OverlayMatIconInput = {
    text: '',
    icon: '',
    color: 'primary',
    isOpen: false,
    isLoading: false,
    matIcon: true
  };

  constructor() {}

  ngOnInit(): void {
    this.overlayInput = {
      ...this.overlayInput,
      text: this.matIconOverlayInput.text,
      icon: this.matIconOverlayInput.icon
    };
  }
}
